import React from 'react'

export const CertificatesPromoBadge = ({ text }: { text: string }) => (
  <span
    className='mc-text-x-small mc-text--uppercase mc-bg-primary mc-text--bold mc-corners--1'
    style={{ padding: '2px 6px' }}
  >
    {text}
  </span>
)
